import dispatchAxiosUpdatedEvent from './axios-updated-event';

function handleRequest(error, tag = 'AXIOS') {
	const currentRequestNumber = error.config.number;
	const currentRequestNumberPadded = currentRequestNumber.toString().padStart(3, 0);
	const labelColor = '#b22222';
	const tagTextColor = tag === 'AXIOS' ? 'white' : 'red';
	const requestMethod = error.config.method.toUpperCase();

	const errorCode = error.response.status || error.response.statusCode;
	let label = error.config.url;

	if (error?.data && error.data.mime) label += ' (' + error.data.mime + ')';

	window.debug.axios.requests[currentRequestNumber].success = false;

	console.groupCollapsed(
		`%c[${tag}#${currentRequestNumberPadded}] ${requestMethod}%cERROR: ${errorCode}%c`,
		`background:#35495e ; padding: 3px 6px 2px 4px; border-radius: 3px 0 0 3px;  color: ${tagTextColor}`,
		`background:${labelColor} ; padding: 3px 6px 2px 6px; border-radius: 0 3px 3px 0;  color: #fff`,
		'background:transparent'
	);
	console.error(`[${tag}#${currentRequestNumberPadded}] at:`, label);
	console.log('ERROR', error);
	console.groupEnd();

	if (errorCode === 401 || errorCode === 419) {
		window.location.href = '/login';
		console.table(window.debug.axios.requests);
	}

	dispatchAxiosUpdatedEvent();
}

export default handleRequest;
